import { useThemes } from "@app/store/themeStore";
import { useMemo } from "react";

export function useFrameworkSpecificThemesAndSubthemes(framework?: string) {
    const frameworkFilter =
        // we only have evs for now, so no need to overengineering
        framework === "ecovadis" ? { withObjectiveRequired: true } : {};

    const { themes } = useThemes(frameworkFilter);

    const themeIds = useMemo(() => {
        return themes?.map((theme) => theme.id).filter((id) => id) as string[];
    }, [themes]);

    const subthemeIds = useMemo(() => {
        return themes
            ?.flatMap((theme) =>
                theme.subthemes
                    .filter((subtheme) => subtheme.active)
                    .map((subtheme) => subtheme.id),
            )
            .filter((id) => id) as string[];
    }, [themes]);

    return { themeIds, subthemeIds };
}
